/**
 * Friendly names for the legacy commodity family codes.
 *
 * The legacy backup carries only the bare codes (the descriptions table was
 * empty), so this glossary decodes the mnemonics that are unambiguous in a
 * housebuilding context. Families not listed here display their raw code —
 * deliberately: a wrong guess in front of the customer is worse than a code.
 * Replace/extend once the customer supplies their official commodity list.
 */
export const COMMODITY_NAMES: Record<string, string> = {
  AGGR: 'Aggregates',
  APPL: 'Appliances',
  BEDF: 'Bedroom Furniture',
  BLOC: 'Blocks',
  BRIC: 'Bricks',
  BSUN: 'Builders’ Sundries',
  CAVT: 'Cavity Trays',
  CEME: 'Cement & Mortar',
  CONC: 'Concrete',
  DRAI: 'Drainage',
  DRYL: 'Drylining',
  DUCT: 'Ducting',
  ELEC: 'Electrical',
  EXDR: 'External Doors',
  EXWK: 'External Works',
  FASC: 'Fascias',
  FEES: 'Fees',
  FENC: 'Fencing',
  FIXG: 'Fixings',
  FLAG: 'Paving Flags',
  FLCV: 'Floor Coverings',
  FLOR: 'Flooring',
  FLUE: 'Flues',
  GRPP: 'GRP Products',
  INDR: 'Internal Doors',
  INSU: 'Insulation',
  IRON: 'Ironmongery',
  JOIS: 'Joists',
  KITN: 'Kitchens',
  LABR: 'Labour',
  LAND: 'Landscaping',
  LINT: 'Lintels',
  MBOX: 'Meter Boxes',
  MISC: 'Miscellaneous',
  MTWK: 'Metalwork',
  OVHD: 'Overheads',
  PAIT: 'Paint',
  PLNT: 'Plant',
  PLUM: 'Plumbing',
  REIN: 'Reinforcement',
  RTRS: 'Roof Trusses',
  SANI: 'Sanitaryware',
  SHWR: 'Showers',
  SIGN: 'Signage',
  SINK: 'Sinks',
  STNE: 'Stone',
  STRS: 'Stairs',
  TARM: 'Tarmac',
  TIMB: 'Timber',
  VANI: 'Vanity Units',
  WINS: 'Windows',
  WSTE: 'Waste',
};

/** Display label for a commodity family: decoded name, else the raw code. */
export function commodityLabel(code: string): string {
  return COMMODITY_NAMES[code] || code;
}
